import Swiper from 'swiper/bundle';
import { swiperOptions } from './module/SwiperFunctions';

if (document.getElementById('river_article_more')) {
  document.getElementById('river_article_more').addEventListener(
    'click',
    () => {
      document.querySelectorAll("li[name='river_article_li']").forEach((el) => {
        el.classList.remove('d-none');
      });
      document.getElementById('river_article_more').classList.add('d-none');
    },
    { once: true }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  // --- Swiperの設定 top.js mainview から引用---
  if (document.querySelector('.river-mainView__swiper')) {
    new Swiper(
      '.river-mainView__swiper',
      swiperOptions({
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
          nextEl: '.u-swiperButton--next',
          prevEl: '.u-swiperButton--prev',
        },
        pagination: {
          el: '.u-swiperPagination',
          bulletClass: 'u-swiperPaginationBullet',
          bulletActiveClass: 'u-swiperPaginationBullet--active',
          clickable: true,
        },
      })
    );
  }

  // --- スクロール制御 ---
  const header = document.querySelector('.header.is-kawanokyoto-hide');
  const mv = document.querySelector('.mainView');

  if (header && mv) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (window.innerWidth > 768) {
            if (!entry.isIntersecting) {
              header.classList.add('is-show');
            } else {
              header.classList.remove('is-show');
            }
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(mv);
  }
});
